import Vue from 'vue'
import VueRouter from 'vue-router'
import layout from '@/views/layout/index.vue'
import HomeView from '../views/HomeView.vue'

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
}

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		redirect: '/home',
		component: layout,
		children: [
			{
				path: '/home',
				name: 'home',
				component: HomeView,
				meta: {
					title: 'Memory Cube'
				}
			},
			{
				path: '/product',
				name: 'product',
				component: () => import('@/views/productCenter.vue'),
				meta: {
					title: 'Product Center'
				}
			},
			{
				path: '/support',
				name: 'support',
				component: () => import('@/views/support.vue'),
				meta: {
					title: 'Technical Support'
				}
			},
			{
				path: '/distribute',
				name: 'distribute',
				component: () => import('@/views/distribute.vue'),
				meta: {
					title: 'Download'
				}
			},
			{
				path: '/aboutus',
				name: 'aboutus',
				component: () => import('@/views/aboutus.vue'),
				meta: {
					title: 'About Us'
				}
			}
		]
	},
	{
		path: '/agreement',
		name: 'agreement',
		component: () => import('@/views/agreement.vue'),
		meta: {
			title: 'Service Agreement'
		}
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

// 路由守卫 - 自动更新页面标题
router.beforeEach((to, from, next) => {
	if (to.matched && to.matched.length > 0) {
		const currentRoute = to.matched[to.matched.length - 1];
		if (currentRoute.meta && currentRoute.meta.title) {
			document.title = currentRoute.meta.title;
		}
	}
	next();
})

export default router
